import React, {useState} from "react";


import ReactApexChart from "react-apexcharts";
import { Shimmer, ShimmerElementsGroup, ShimmerElementType } from '@fluentui/react/lib/Shimmer';
import { Row, Col } from "react-bootstrap";
import { useGetAllClientLAstMonthConnections } from "../../hooks/useOfCharts";

const AccessesPerDayStackAllClients = (props) => {

  const [chartData, setChartData] = useState(null);        
  useGetAllClientLAstMonthConnections(chartData, setChartData);

    const chartConfig = {       
      series: chartData,   

      options: {
            chart: {
              type: 'bar',
              height: 350,
              stacked: true,
              toolbar: {
                show: true
              },
              zoom: {
                enabled: true
              }
            },
            responsive: [{
              breakpoint: 480,
              options: {
                legend: {
                  position: 'bottom',
                  offsetX: -10,
                  offsetY: 0
                }
              }
            }],
            plotOptions: {
              bar: {
                horizontal: false,
                borderRadius: 10
              },
            },

            legend: {
              position: 'right',
              offsetY: 40
            },
            fill: {
              opacity: 1
            }
      },
    }

    return (   
        <>
          {chartConfig && chartData && 
            <ReactApexChart options={chartConfig.options} series={chartConfig.series} type="bar" width="100%" height="250px" />
          }
          {!chartConfig && !chartData && 
            <Shimmer
                customElementsGroup={
                  <Row style={{ display: 'flex' }}>
                    <Col>
                    <ShimmerElementsGroup
                        shimmerElements={[
                            { type: ShimmerElementType.line, width: 50, height: 5,  verticalAlign: 'bottom' },
                            { type: ShimmerElementType.line, width: 150, height: 240, verticalAlign: 'bottom'},
                            { type: ShimmerElementType.line, width: 150, height: 5,  verticalAlign: 'bottom' },
                            { type: ShimmerElementType.line, width: 150, height: 170,  verticalAlign: 'bottom' },
                            { type: ShimmerElementType.line, width: 150, height: 5,  verticalAlign: 'bottom' },
                            { type: ShimmerElementType.line, width: 150, height: 120,  verticalAlign: 'bottom' },
                            { type: ShimmerElementType.line, width: 150, height: 5,  verticalAlign: 'bottom' },
                            { type: ShimmerElementType.line, width: 150, height: 240, verticalAlign: 'bottom'},
                            { type: ShimmerElementType.line, width: 150, height: 5,  verticalAlign: 'bottom' },
                            { type: ShimmerElementType.line, width: 150, height: 150, verticalAlign: 'bottom'},
                            { type: ShimmerElementType.line, width: 150, height: 5,  verticalAlign: 'bottom' },
                            { type: ShimmerElementType.line, width: 150, height: 240, verticalAlign: 'bottom'},
                            { type: ShimmerElementType.line, width: 150, height: 5,  verticalAlign: 'bottom' },
                            { type: ShimmerElementType.line, width: 150, height: 30,  verticalAlign: 'bottom' },
                            { type: ShimmerElementType.line, width: 150, height: 5,  verticalAlign: 'bottom' },
                            { type: ShimmerElementType.line, width: 150, height: 100, verticalAlign: 'bottom'},
                            { type: ShimmerElementType.line, width: 150, height: 5,  verticalAlign: 'bottom' },
                        ]}
                    />
                    </Col>
                  </Row>
                }
                className="pt-4"
                isDataLoaded={chartConfig !== null}>
            </Shimmer>
          }
      </>
    );
};

export default AccessesPerDayStackAllClients;